import { render, staticRenderFns } from "./NotificationPopup.vue?vue&type=template&id=29387257&"
import script from "./NotificationPopup.vue?vue&type=script&lang=js&"
export * from "./NotificationPopup.vue?vue&type=script&lang=js&"
import style0 from "./NotificationPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports